import { render, staticRenderFns } from "./VTextarea.vue?vue&type=template&id=1da3a18d&scoped=true"
import script from "./VTextarea.vue?vue&type=script&lang=js"
export * from "./VTextarea.vue?vue&type=script&lang=js"
import style0 from "./VTextarea.vue?vue&type=style&index=0&id=1da3a18d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1da3a18d",
  null
  
)

export default component.exports